import {
  UPDATE_MODAL,
} from './types';

export function updateModal(show,content){
    return {
        type: UPDATE_MODAL,
        payload: {show: show, content: content},
    };
}



// WEBPACK FOOTER //
// ./src/app/actions/modal.js